import createBrowserHistory from 'history/createBrowserHistory'
export const history = createBrowserHistory()



// WEBPACK FOOTER //
// ./src/history.js